import { render, staticRenderFns } from "./FormControlMRegistrantsRegistrantsUsername.vue?vue&type=template&id=4bc7da82&scoped=true"
import script from "./FormControlMRegistrantsRegistrantsUsername.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMRegistrantsRegistrantsUsername.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMRegistrantsRegistrantsUsername.vue?vue&type=style&index=0&id=4bc7da82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7da82",
  null
  
)

export default component.exports